export enum Language {
  Dutch = 'Dutch',
  English = 'English'
}

export enum MemberStatus {
  NA = 'NA',
  Invited = 'Invited',
  Active = 'Active'
}
